
import NavigationMenu from "@/components/layout/NavigationMenu";
import { useTranslation } from "react-i18next";

const LoadingState = () => {
  const { t } = useTranslation('ai-analysis');
  return (
    <div className="min-h-screen bg-gradient-to-b from-golf-50 to-white">
      <NavigationMenu />
      <div className="container mx-auto p-8">
        <div className="flex justify-center items-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-golf-600 mx-auto mb-4"></div>
            <h2 className="text-xl font-semibold text-golf-800">{t('loading.title')}</h2>
            <p className="text-gray-600">{t('loading.message')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingState;
